import React, { Component } from 'react'
import { Row, Col, Icon } from 'antd'
import moment from 'moment'

import { userStatus } from '@texts/users'

import * as style from './style.scss'

class Details extends Component<any> {
    render() {
        const { info } = this.props
        return (
            <>
                <Row
                    gutter={28}
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        width: '100%',
                        flex: 1,
                        backgroundColor: info.status ? 'initial' : '#ffe1e1',
                        marginBottom: '0.7rem'
                    }}
                >
                    <Col xs={5} className={style.col_style}>
                        <strong className={style.title}>קופת חולים:</strong>
                        {info.hmo_id ? (
                            <a href={`/insurance/${info.hmo_id}`} target="_blank" className={style.link}>
                                {info.hmo_name} ({info.hmo_id})
                            </a>
                        ) : (
                            'לא הוזנה קופ"ח'
                        )}
                    </Col>
                    <Col xs={5} className={style.col_style}>
                        <strong className={style.title}>תכנית קופ"ח:</strong>
                        {info.hmo_id && info.hmo_plan_id ? (
                            <a
                                href={`/insurance/${info.hmo_id}/${info.hmo_plan_id}`}
                                target="_blank"
                                className={style.link}
                            >
                                {info.hmo_plan_name} ({info.hmo_plan_id})
                            </a>
                        ) : (
                            'לא נבחרה תכנית'
                        )}
                    </Col>
                    <Col xs={5} className={style.col_style}>
                        <strong className={style.title}>תכנית קבוצתית:</strong>
                        {info.provider_id ? `${info.provider_name} (${info.provider_id})` : 'לא נבחרה תכנית'}
                    </Col>
                    <Col xs={3} className={style.col_style}>
                        <strong className={style.title}>תאריך לידה:</strong>
                        {info.birthday ? moment(info.birthday).format('DD/MM/YYYY') : 'לא הוזן תאריך'}
                    </Col>
                    <Col xs={3} className={style.col_style}>
                        <strong className={style.title}>גיל:</strong>
                        {info.birthday ? moment().diff(info.birthday, 'years') : 'לא הוזן תאריך'}
                    </Col>
                    <Col xs={3} className={style.col_style}>
                        <strong className={style.title}>מצב:</strong>
                        {info.status && userStatus[info.status] ? (
                            userStatus[info.status]
                        ) : (
                            <strong style={{ color: 'red' }}>
                                <Icon type="close" /> כשל בהרשמה
                            </strong>
                        )}
                    </Col>
                </Row>
                {info.identity_date && (
                    <Row
                        gutter={28}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            width: '100%',
                            flex: 1,
                            backgroundColor: info.status ? 'initial' : '#ffe1e1'
                        }}
                    >
                        <Col xs={5} className={style.col_style}>
                            <strong className={style.title}>תאריך הנפקת תעודת זהות:</strong>
                            {info.identity_date ? moment(info.identity_date).format('DD/MM/YYYY') : 'לא הוזן תאריך'}
                        </Col>
                        <Col xs={5} className={style.col_style}>
                            <strong className={style.title}>הונפק דרכון בשלוש שנים האחרונות:</strong>
                            {info.passport ? 'כן' : 'לא'}
                        </Col>
                        <Col xs={5} className={style.col_style}>
                            <strong className={style.title}>יציאה מהארץ בשלוש שנים האחרונות:</strong>
                            {info.departure ? 'כן' : 'לא'}
                        </Col>
                        <Col xs={5} className={style.col_style}>
                            <strong className={style.title}>מאשר קבלת פרסומות:</strong>
                            {info.ads ? 'כן' : 'לא'}
                        </Col>
                    </Row>
                )}
            </>
        )
    }
}

export default Details
